import { render, staticRenderFns } from "./LogoView.vue?vue&type=template&id=24192719"
import script from "./LogoView.vue?vue&type=script&lang=ts"
export * from "./LogoView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports